require('es6-promise').polyfill()
import axios from 'axios'
import queryString from 'query-string'

// URL and endpoint constants
const API_URL = 'api/v1.0'
function getApiUrl (url) {
  return API_URL + url
}

function handleApiError (cmd, error, errorFnOrMsg, context) {
  console.log('Error in ' + cmd, error)
  if (error.response.status === 401 && context) {
    context.$auth.logout()
    location.replace('/')
    // context.$route.push('/login')
  } else if (error.response.status === 409 && context) {
    context.reportApiError(error.response.data.message)
  } else if (typeof errorFnOrMsg === 'function') {
    errorFnOrMsg(error)
  } else if (typeof errorFnOrMsg === 'string') {
    context.reportApiError('Server error while ' + errorFnOrMsg)
  }
}
function downloadFromResponse (response, filename) {
  // console.log('downloadFromResponse', response)
  const disposition = response.headers['content-disposition']
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  const matches = filenameRegex.exec(disposition)
  // console.log(filename, matches)
  if (matches != null && matches[1]) {
    filename = matches[1].replace(/['"]/g, '')
  }
  console.log(response.data.length, response.headers['content-type'])
  let blob = new Blob([response.data], {type: response.headers['content-type']})
  let a = document.createElement('a')
  document.body.appendChild(a) // Add the element to the DOM; firefox fix
  a.style = 'display: none'
  a.href = window.URL.createObjectURL(blob)
  console.log(a.href)
  a.download = filename
  a.click()
  window.URL.revokeObjectURL(a.href)
}

export default {
  handleVueTableApiError (tableName, error, context) { handleApiError('Table api.get', error, null, context) },
  getAPI_URL (url) {
    return getApiUrl(url)
  },
  queryStringify (url, obj) {
    return url + '?' + queryString.stringify(obj)
  },
  get (url, queryObj, successFn, errorFn, context) {
    url = getApiUrl(url)
    if (queryObj) {
      url += '?' + queryString.stringify(queryObj)
    }
    console.log('api.get', url)
    axios.get(url)
    .then(response => {
      successFn(response.data)
    })
    .catch(error => { handleApiError('api.get', error, errorFn, context) })
  },
  putUpdate (url, data, successFn, errMsg, alertHandler) {
    console.assert(alertHandler)
    console.assert(alertHandler.reportApiError)
    url = getApiUrl(url)
    console.log('api.put', url, data)
    axios.put(url, data)
    .then(response => {
      // console.log('put response', response)
      successFn(response.data)
    })
    .catch(error => { handleApiError('api.put', error, errMsg, alertHandler) })
  },
  post (url, data, successFn, errMsg, alertHandler) {
    console.assert(alertHandler)
    console.assert(alertHandler.reportApiError)
    url = getApiUrl(url)
    console.log('api.post', url, data)
    axios.post(url, data)
    .then(response => {
      // console.log('post response', response)
      successFn(response.data)
    })
    .catch(error => { handleApiError('api.post', error, errMsg, alertHandler) })
  },
  delete (url, successFn, errMsg, alertHandler) {
    console.assert(alertHandler)
    console.assert(alertHandler.reportApiError)
    url = getApiUrl(url)
    console.log('api.delete', url)
    axios.delete(url)
    .then(response => {
      // console.log('delete response', response)
      successFn(response.data)
    })
    .catch(error => { handleApiError('api.delete', error, errMsg, alertHandler) })
  },

  downloadPost (url, data, filename) {
    url = getApiUrl(url)
    axios({
      method: 'post',
      url: url,
      data: data,
      responseType: 'arraybuffer'
    })
    .then(response => {
      downloadFromResponse(response, filename)
    })
    .catch(error => { handleApiError('api.post', error, null, null) })
  },
  downloadFromResponse (response, filename) { return downloadFromResponse(response, filename) },
  uploadPost (url, files, onSuccess, onError = null, onProgress = null, options = {}) {
    let onlySingle = true
    let field = 'file'
    let state = {}
    url = getApiUrl(url)
    let fmData = new FormData()

    if (onlySingle) {
      fmData.append(field, files[0])
    } else {
      for (let x of files) {
        if (!isNaN(x)) {
          fmData.append(field, files[x])
        }
      }
    }

    state.loading = 1
    let axioscfg = {
      method: 'POST',
      url: url,
      data: fmData,
      onUploadProgress: function (event) {
        if (event.lengthComputable) {
          state.progress = 100 * Math.round(event.loaded) / event.total
          // console.log(state)
          if (typeof onProgress === 'function' && onProgress) {
            onProgress(state)
          }
        }
      }
    }
    axios(axioscfg)
    .then((response) => {
      state.loading = 2
      // console.log('Upload OK', response)
      if (typeof onSuccess === 'function' && onSuccess) {
        onSuccess(response, state)
      }
    })
    .catch((error) => {
      state.loading = 3
      state.hasError = true
      console.log('Upload ERROR', error)
      if (typeof onError === 'function' && onError) {
        onError(error, state)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js